import { v4 } from 'uuid'

import { FormItemDraggableBase } from './form-item-draggable-base'
import { IconEnum } from '../../../../../assets/icons'
import { FormItemType } from '../../constants/form-builder.constants'

export const CheckboxDraggable = () => {
  const id = v4()
  const type = FormItemType.Checkbox

  return (
    <FormItemDraggableBase
      icon={IconEnum.CheckSquare}
      id={id}
      title="formBuilder.checkbox"
      type={type}
    />
  )
}
